








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class MarqueeText extends Vue {
  @Prop({ default: 'left' }) direction?: 'left' | 'right';
  @Prop({ default: 0 }) positionTop?: number;
  @Prop() text!: string;
  @Prop() isEnd!: boolean;

  public width = 'auto';

  created() {
    setTimeout(() => {
      this.$emit('marqueeEnd')
    }, 10000)
  }

  mounted() {
    const area = this.$refs.area as Element
    this.width = `${area.clientWidth}px`
  }

  get directionClass() {
    return { [`to_${this.direction}`]: true }
  }
}
